import CryptoJS from 'crypto-js';
import { URLParam } from '../app/Interfaces/system/params.interfaces';

export const parseDate = (value: string) => {
  const date = new Date(`${value}T00:00:00`);
  return isNaN(date.getTime()) ? undefined : date;
};

export const parseId = (value: string) =>
  /^\d+$/.test(value) ? Number(value) : value;

export const decryptParam = (value: string) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      value,
      process.env['NX_CRYPTO_PUBLIC_KEY'] ?? ''
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return '';
  }
};

export const readParam = <T>(
  searchParams: URLSearchParams,
  param: URLParam<T>
) => {
  const values: unknown[] = [];

  for (const raw of searchParams.getAll(String(param.label))) {
    const value = param.isEncrypted ? decryptParam(raw) : raw;
    if (!value) {
      continue;
    }

    const parsed = param.parse ? param.parse(value) : value;
    if (parsed !== undefined) {
      values.push(parsed);
    }
  }

  if (!values.length) {
    return undefined;
  }

  return param.multiple ? values : values[0];
};
